<template>
  <InfiniteScroll class="genres" :load="loadMore" :loading="loading" :isEnd="isEnd">
    <div class="page-header">
      <span>Genres</span>
      <img
        src="@/assets/images/icon/search-black.png"
        @click="$router.push('/novel/search')"
        alt=""
      >
    </div>
    <div class="tag-list">
      <div class="scroll-container">
        <a
          href="javascript:void(0);"
          v-for="(tag, i) in tagList"
          :key="tag.id + '_' +  i"
          :class="['tag', activeTag === tag.name ? 'active': '']"
          @click="tagChange(tag)"
        >
            {{ tag.name }}
        </a>
      </div>
    </div>
    <div class="comics-list">
      <List :data="comicsList" :displayStyle="4" @goDetail="goDetail" />
    </div>
  </InfiniteScroll>
</template>

<script>
import { getSysConfig, searchNovel, getNovelChapters } from '@/api';

import InfiniteScroll from '@/components/InfiniteScroll.vue';
import List from '@/components/List';

//
export default {
  components: {
    List,
    InfiniteScroll,
  },
  data() {
    return {
      activeTag: 'All',
      loading: false,
      isEnd: false,
      page: 1,
      pageSize: 10,
      tagList: [],
      comicsList: [],
    };
  },
  created() {
    this.init();
  },
  methods: {
    async init() {
      this.getTagList();
      this.getComicsList();
    },
    async getTagList() {
      const res = await getSysConfig();
      if (res.code !== 0) return;
      this.tagList = (res.data.genres || []);
      this.tagList.unshift({ id: '', name: 'All' });
    },
    tagChange(tag) {
      if (tag.name === this.activeTag) return;
      this.isEnd = false;
      this.activeTag = tag.name;
      this.page = 1;
      this.getComicsList();
    },
    async getComicsList() {
      const { activeTag, page } = this;
      const res = await searchNovel({ tag: activeTag === 'All' ? 'all' : activeTag, page, per_page: this.pageSize });
      if (res.code !== 0) return;
      if (activeTag === this.activeTag) { // 防止异步列表错乱
        if (page === 1) {
          this.comicsList = res.data.list || [];
        } else {
          this.comicsList = this.comicsList.concat(res.data.list || []);
        }
        this.isEnd = Boolean(!res.data.has_next && res.data.list && res.data.list.length);
      }
      this.loading = false;
    },
    loadMore() {
      this.isEnd = false;
      this.loading = true;
      this.page += 1;
      this.getComicsList();
    },
    async goDetail(novelId) {
      const res = await getNovelChapters(novelId);
      if (res.code !== 0) return;
      const { id = '' } = res.data[0];
      this.$router.push(`/novel/${novelId}/chapter/${id}`);
    },
  },
};
</script>

<style lang="less" scoped>
.genres {
  position: relative;
  .page-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: @black;
    font-size: @fontLarge;
    font-weight: 700;
    height: 44px;
    padding: 0 16px;
    position: sticky;
    position: -webkit-sticky;
    width: 100vw;
    top: 0;
    background-color: #fff;
    z-index: 10;
    img {
      width: 24px;
      height: 24px;
    }
  }
  .tag-list {
    padding: 16px 0 16px 16px;
    overflow-y: hidden;
    overflow-x: scroll;
    position: sticky;
    position: -webkit-sticky;
    width: 100vw;
    top: 44px;
    z-index: 10;
    background-color: #fff;
    .scroll-container {
      display: inline-flex;
      flex-wrap: nowrap;
      min-width: 100%;
      .tag {
        height: 24px;
        line-height: 24px;
        padding: 0 8px;
        border-radius: 12px;
        font-size: @fontMedium;
        color: @gray;
        white-space: nowrap;
        &.active {
          color: rgba(42, 207, 174, 1);
          .transparent-theme(.15);
        }
      }
    }
  }

}

</style>
